const toggle_update = async (email1,state,setState) => {
	//==================================
	const temp = state
	const index = temp.students.findIndex( ele => ele.email1 === email1 )
	temp.students[index].displayUpdate = !temp.students[index].displayUpdate 
	await setState({...state,students:temp.students})
}

export default toggle_update